import { colors } from '@cimpress/react-components';

const DottedLine = ({ ...props }) => {
  return <div style={{ borderBottom: `1px dashed ${colors.alloy}`, ...props.styles }} {...props} />;
};

export default DottedLine;
